import { useContext, useState } from 'react';
import {Link, NavLink} from 'react-router-dom';
import AppContext from "../../context";

import styles from '../../styles/Sidebar.module.scss';
import {Capacitor} from "@capacitor/core";

function Sidebar() {
	const context = useContext(AppContext);

	const [open, setOpen] = useState(false);
	const businessType = context.domain.businessType;
	const isHybrid = businessType === 'hybrid' || businessType === 'hybrid-new';
	const isExperience = businessType === 'experiences' || isHybrid;
	const showHealthScreening = !!context.domain.healthScreeningEnabled && businessType !== 'experiences';

	return (
		<div className={`${styles.sidebar} ${open ? styles.open : null} ${Capacitor.isNativePlatform() ? styles.native : styles.native}`}>
			<Link to="/">
				<img src={context.domain.logo || `https://surecode.fra1.cdn.digitaloceanspaces.com/${context.domain._id}/logo.svg`} alt={context.domain.name} />
			</Link>

			{context.domain.membershipMode ?
				<div className={styles.nav}>
					<nav onClick={() => { setOpen(false) }}>
						<NavLink to="/admin/members">Members</NavLink>
						<NavLink to="/admin/membership-plans">Membership Plans</NavLink>
						<NavLink to="/admin/transactions">Transactions</NavLink>
						{/* <NavLink to="/admin/access-history">Access History</NavLink> */}
						<NavLink to="/admin/coupons">Coupons</NavLink>
						{showHealthScreening && <NavLink to="/admin/health-screening">Health Screening</NavLink>}
						<NavLink to="/admin/settings">Settings</NavLink>
						<NavLink to="/log-out">Log Out</NavLink>
						<p>Powered by <a href="https://surecodesoftware.com/" target="_blank" rel="noopener noreferrer">Surecode</a></p>
					</nav>
				</div>
				: (context.domain.businessType === 'clinic' || context.domain.businessType === 'salon' || context.domain.businessType === 'restaurant') ?
				<div className={styles.nav}>
					<nav onClick={() => { setOpen(false) }}>
						<NavLink to="/admin/service-bookings">Bookings</NavLink>
						<NavLink to="/admin/services">Services</NavLink>
						<NavLink to="/admin/staff">Staff</NavLink>
						<NavLink to="/admin/availability">Availability</NavLink>
						<NavLink to="/admin/wallet-packages">Wallet Packages</NavLink>
						<NavLink to="/admin/wallet-transactions">Wallet Transactions</NavLink>
						<NavLink to="/admin/users">Users</NavLink>
						<NavLink to="/admin/transactions">Transactions</NavLink>
						<NavLink to="/admin/discount-codes">Discount Codes</NavLink>
						<NavLink to="/admin/settings">Settings</NavLink>
						<NavLink to="/log-out">Log Out</NavLink>
						<p>Powered by <a href="https://surecodesoftware.com/" target="_blank" rel="noopener noreferrer">Surecode</a></p>
					</nav>
				</div>
				:
				<div className={styles.nav}>
					<nav onClick={() => { setOpen(false) }}>
						<NavLink to="/admin/bookings">Manage Bookings</NavLink>
						<NavLink to="/admin/products">Pricing</NavLink>
						{isExperience && <NavLink to="/admin/experiences">Classes</NavLink>}
						{isExperience && <NavLink to="/admin/upcoming-events">Class Schedule</NavLink>}
						{isExperience && <NavLink to="/admin/class-bookings">Class Bookings</NavLink>}
						{isHybrid && <NavLink to="/admin/members">Members</NavLink>}
						{isHybrid && <NavLink to="/admin/membership-plans">Membership Plans</NavLink>}
						<NavLink to="/admin/users">Users</NavLink>
						<NavLink to="/admin/minors">Minors</NavLink>
						<NavLink to="/admin/transactions">{isHybrid ? "Token Transactions" : "Transactions"}</NavLink>
						{isHybrid && <NavLink to="/admin/membership-transactions">Membership Transactions</NavLink>}
						<NavLink to="/admin/studios">Studios</NavLink>
						<NavLink to="/admin/discount-codes">Discount Codes</NavLink>
						{isHybrid && <NavLink to="/admin/coupons">Coupons</NavLink>}
						{showHealthScreening && <NavLink to="/admin/health-screening">Health Screening</NavLink>}
						<NavLink to="/admin/settings">Settings</NavLink>
						<NavLink to="/log-out">Log Out</NavLink>
						<p>Powered by <a href="https://surecodesoftware.com/" target="_blank" rel="noopener noreferrer">Surecode</a></p>
					</nav>
				</div>
			}

			<div id="hamburger" onClick={() => { setOpen(!open) }} className={open ? "close" : null}><span /></div>

			<span />
		</div>
	);
}

export default Sidebar;
